/* eslint-disable */
import { tableBlock, el } from '@aspectus/vue-dermis';

export default el('ds-table-body', tableBlock, { tag: 'tbody' }, 'body');
